import styled from 'styled-components';
import React from 'react';
import Pic from '../assets/images/people.png'

const YourExperience = ({ title }) => {
    return (
        <Text>
            Your
            <Image src={Pic} alt="Image description" />
            experience, as an <Highlight>integral part</Highlight> of {title ? title : 'this'} organization, <Bold>matters</Bold>.
        </Text>
    )
}
export default YourExperience

const Text = styled.div`
font-weight: 500;
font-size: 44px;
line-height: 1.4;
color: #2A3039;

@media (max-width: 768px) {
    font-size: 38px;
}
`

const Image = styled.img`
    width:162px;
    display: inline;
    vertical-align: middle;
    margin-left: 0.25em;
    margin-right: 0.25em;
`

const Highlight = styled.span`
background: #EBF1FD;
border-radius: 40px;
padding:0px 16px;
margin:0px -8px;
`

const Bold = styled.span`
    font-weight:600;
    color:#2D70E2;
`
